import { render, staticRenderFns } from "./DossierDetail.vue?vue&type=template&id=999ae648&"
import script from "./DossierDetail.vue?vue&type=script&lang=js&"
export * from "./DossierDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports